import LoadingOverlay from "react-loading-overlay";
import "./App.css";
import { InferenceSession, Tensor } from "onnxruntime-web";
import React, { useContext, useEffect, useRef, useState } from "react";
import "./assets/scss/App.scss";
import { handleImageScale } from "./components/helpers/scaleHelper";
import { onnxMaskToImage } from "./components/helpers/maskUtils";
import { modelData } from "./components/helpers/onnxModelAPI";
import Stage from "./components/Stage";
import AppContext from "./components/hooks/createContext";

// import LoadingOverlay from 'react-loading-overlay';
const ort = require("onnxruntime-web");
/* @ts-ignore */
import npyjs from "npyjs";
import html2canvas from "html2canvas";
import apiClient from "./api/apiClient";

const App = ({ stepperFormdataImage, handleChange, stepperFormdata }) => {
  const [modelScale, setModelScale] = useState(null);
  const [dynamicImageURL, setDynamicImageURL] = useState(null);
  const [imageResponse, setImageResponse] = useState(null);
  const [imagePattern, setimagePattern] = useState(null);
  const [imageUpload, setimageUpload] = useState("");

  const [isActive, setActive] = useState(false);
  const [ImagePreview, setImagePreview] = useState(false);
  // Define image, embedding and model paths
  const IMAGE_PATH = "/assets/data/dogs.jpg";
  //  const IMAGE_PATH =dynamicImageURL ;
  const IMAGE_EMBEDDING = "assets/data/dogs_embedding.npy";
  const art = "assets/data/art11.jpg";
  const MODEL_DIR = "model/sam_onnx_example.onnx";
  const {
    clicks: [clicks],
    image: [image, setImage],
    maskImg: [maskImg, setMaskImg],
  } = useContext(AppContext);

  useEffect(() => {
    handleChange("mask", maskImg);
  }, [maskImg]);
  const [model, setModel] = useState(null); // ONNX model
  const [tensor, setTensor] = useState(null); // Image embedding tensor

  // The ONNX model expects the input to be rescaled to 1024.
  // The modelScale state variable keeps track of the scale values.

  // Initialize the ONNX model. load the image, and load the SAM
  // pre-computed image embedding
  useEffect(() => {
    // Initialize the ONNX model
    const initModel = async () => {
      try {
        if (MODEL_DIR === undefined) return;
        const URL = MODEL_DIR;
        const model = await InferenceSession.create(URL);
        setModel(model);
      } catch (e) {
        console.log(e);
      }
    };
    initModel();

    // Load the image
    // const url = new URL(IMAGE_PATH, location.origin);
    // loadImage(url);

    // // Load the Segment Anything pre-computed embedding
    // Promise.resolve(loadNpyTensor(IMAGE_EMBEDDING, "float32")).then(
    //   (embedding) => setTensor(embedding)
    // );
  }, []);

  const loadImage = async (url) => {
    try {
      const img = new Image();
      img.src = url.href;
      img.onload = () => {
        const { height, width, samScale } = handleImageScale(img);
        setModelScale({
          height: height, // original image height
          width: width, // original image width
          samScale: samScale, // scaling factor for image which has been resized to longest side 1024
        });
        img.width = width;
        img.height = height;
        setImage(img);
        setDynamicImageURL(url.href); // Set the dynamic image URL
      };
    } catch (error) {
      console.log(error);
    }
  };

  // Decode a Numpy file into a tensor.
  const loadNpyTensor = async (tensorFile, dType) => {
    let npLoader = new npyjs();
    const npArray = await npLoader.load(tensorFile);
    const tensor = new ort.Tensor(dType, npArray.data, npArray.shape);
    return tensor;
  };

  // Run the ONNX model every time clicks has changed
  useEffect(() => {
    runONNX();
  }, [clicks]);

  const runONNX = async () => {
    try {
      if (
        model === null ||
        clicks === null ||
        tensor === null ||
        modelScale === null
      )
        return;
      else {
        // Preapre the model input in the correct format for SAM.
        // The modelData function is from onnxModelAPI.tsx.
        const feeds = modelData({
          clicks,
          tensor,
          modelScale,
        });
        if (feeds === undefined) return;
        // Run the SAM ONNX model with the feeds returned from modelData()
        const results = await model.run(feeds);
        const output = results[model.outputNames[0]];
        // The predicted mask returned from the ONNX model is an array which is
        // rendered as an HTML image using onnxMaskToImage() from maskUtils.tsx.
        setMaskImg(
          onnxMaskToImage(output.data, output.dims[2], output.dims[3])
        );
      }
    } catch (e) {
      console.log(e);
    }
  };

  const handleFileChange = async (file, filename) => {
    // const file = event.target.files?.[0];
    const formData = new FormData();

    setActive(true);
    if (file) {
      formData.append("input_file", file);
      formData.append("embeddings_filename", filename);
      const imageUrl = URL.createObjectURL(file);
      // setDynamicImageURL(imageUrl);
      const url = new URL(imageUrl, location.origin);
      loadImage(url);
      const results = await apiClient
        .post("/embeddings/", formData)
        .then((results) => {
          setActive(false);
          // Load the Segment Anything pre-computed embedding

          loadNpyTensor(results.data.embeddings_file, "float32").then(
            (embedding) => setTensor(embedding)
          );
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    }
  };

  const findnameget = async () => {
    let blobimage;
    const formData = new FormData();

    if (typeof stepperFormdataImage == "object") {
      blobimage = stepperFormdataImage;

      // formData.append('file', stepperFormdataImage);
    } else {
      async function urlToBlob(url) {
        const response = await fetch(url);
        const blob = await response.blob();
        return blob;
      }

      await urlToBlob(stepperFormdataImage)
        .then((blob) => {
          blobimage = blob;
        })
        .catch(() => {
          console.log("filed to covert blob");
        });
    }

    formData.append("file", blobimage);

    setActive(true);
    let imageUrl;
    if (typeof stepperFormdataImage == "object") {
      imageUrl = URL.createObjectURL(stepperFormdataImage);
    } else {
      imageUrl = stepperFormdataImage;
    }
    // setDynamicImageURL(imageUrl);
    const url = new URL(imageUrl, location.origin);
    loadImage(url);
    try {
      const response = await fetch(
        "https://mockeeembeddings-6jxhkq5r4q-uc.a.run.app/upload",
        {
          method: "POST",
          body: formData,
        }
      );

      setActive(false);
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();

      handleFileChange(blobimage, data?.file_name);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    findnameget();
    // if(typeof stepperFormdataImage =="object" ){

    //   handleFileChange(stepperFormdataImage)
    // }else{
    //   async function urlToBlob(url) {
    //     const response = await fetch(url);
    //     const blob = await response.blob();
    //     return blob;
    // }

    //   urlToBlob(stepperFormdataImage).then((blob)=>{ handleFileChange(blob)}).catch(()=>{
    //     console.log("filed to covert blob");
    //   })

    // }
  }, []);

  const divRef = useRef(null);

  const handleDownload = async () => {
    if (divRef.current) {
      const div = divRef.current;

      // Use html2canvas to capture the content of the div
      const canvas = await html2canvas(div);

      // Convert the canvas to data URL and trigger download
      const imgData = canvas.toDataURL("image/png");
      const a = document.createElement("a");
      a.href = imgData;
      a.download = "image.png";
      a.click();
    }
  };

  const imageToBlob = (image) => {
    return new Promise((resolve) => {
      const canvas = document.createElement("canvas");
      canvas.width = image.width;
      canvas.height = image.height;
      const ctx = canvas.getContext("2d");
      if (ctx) {
        ctx.drawImage(image, 0, 0);
        canvas.toBlob((blob) => {
          if (blob) {
            resolve(blob);
          } else {
            throw new Error("Failed to convert image to Blob.");
          }
        });
      } else {
        throw new Error("Failed to get 2D context from canvas.");
      }
    });
  };

  // const handleSelect = async () => {
  //   if (!image || !maskImg) {
  //     console.error("Error: Image or mask image not provided.");
  //     return;
  //   }

  //   // Convert HTMLImageElements to Blobs
  // const originalFileBlob = await imageToBlob(image);

  // const maskFileBlob = await imageToBlob(maskImg);

  // // Create FormData and append Blobs
  // const formData = new FormData();
  // console.log(maskImg,"jjjjjjjjjjj");
  // formData.append("original_file", originalFileBlob, "original_image.png");
  // formData.append("mask_file", maskFileBlob, "mask_image.png");
  // if(imagePattern){  formData.append("pattern", imagePattern);}

  // setActive(true)
  //   try {
  //     const result = await apiClient.post("mockups/",formData); // Fill in the API endpoint URL
  //     setActive(false)
  //     console.log(result,"ddddd")
  //     setImagePreview(true)
  //     setImageResponse(result.data.file)
  //     // Handle result
  //   } catch (error) {
  //     console.error("Error:", error);
  //   }
  // };

  const handleimage = (value) => {
    handleChange("uploadmask", value);
  };

  useEffect(() => {
    const uploadmaskimage =
      stepperFormdata.uploadmask &&
      URL.createObjectURL(stepperFormdata.uploadmask);
    setimageUpload(uploadmaskimage);
  }, [stepperFormdata.uploadmask]);
  return (
    <div>
      {/* <h3 className="text-center fw-normal mb-3 ">Add a new Listing</h3> */}
      <div className="row">
        {/* <App/> */}
        <div className="col-md-5 text-start ">
          <p>
            Use Our Ai Assisted tool to mask the product. You can also upload
            your custom mask{" "}
          </p>
          <div className="mt-3  ">
            {/* <img src="../assets/images/mockup-pic1.png" alt="" /> */}
            {imageUpload && (
              <img
                src={imageUpload}
                alt=""
                width={"100%"}
                style={{ height: "300px", objectFit: "contain " }}
              />
            )}
          </div>

          <div>
            <div className="form-group w-100 mb-3 mt-5 ">
              <label
                style={{
                  backgroundColor: "#f2f2f2",
                  cursor: "pointer",
                  border: "2px dashed #000",
                }}
                className="p-3 w-100 rounded-4 "
                htmlFor="file"
              >
                Upload Mask
              </label>
              <input
                type="file"
                onChange={(e) => handleimage(e.target.files?.[0])}
                className="form-control-file hidden"
                id="file"
              />
            </div>
          </div>
        </div>

        <div className="col-md-7" style={{ height: "500px", overflow: "auto" }}>
          <div
            className=" shadow bg-white   rounded-4 border-2 m-2 "
            style={{ borderStyle: "dashed", borderColor: "#000" }}
          >
            {/* <div className="canvas-container" style={{height:"450px"}}> */}
            {/* <canvas id="canvas" style={{width:"100%" , height:"100%"}}> </canvas> */}
            <div style={{ padding: "20px" }}>
              <div className="container " style={{ marginTop: "2rem" }}>
                {ImagePreview ? (
                  ""
                ) : (
                  //       <div className="p-5 " >
                  //  <button style={{backgroundColor:"blue",padding:"10px",color:"white",borderRadius:"10px"}} className="p-5 btn" onClick={()=>setImagePreview(false)}>back</button>
                  //  <div className="p-5" style={{display:"flex",justifyContent:"center",}}>
                  //       <img src={imageResponse||"https://biopet-bucket.s3.us-west-1.amazonaws.com/healthhop/1704800030067-davido.png"}/>
                  //       </div>
                  //       </div>
                  <>
                    <LoadingOverlay
                      active={isActive}
                      spinner
                      text="Processing your image..."
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          border: "2px soild red",
                        }}
                        className=""
                      >
                        {/* <div className="p-5  d-flex align-items-center justify-content-center">
        <input
          hidden
          type="file"
          id="q"
          accept="image/*"
          multiple
          style={{ width: "100%", backgroundColor: "#DFDFDF" }}
          className="form-control"
          onChange={handleFileChange}
        />
      <div className="row">
        <div className="col-lg-8">
          <label
            className="px-5 py-3 my-2 w-100 text-center"
            htmlFor="q"
            style={{
              backgroundColor: "rgb(245,245,245)",
              borderRadius: "9px",
              border: "2px dashed rgb(176,175,173)",
            }}
          >
            Upload Mockee image
          </label>
        </div>
      </div>
      </div> */}
                        {/* <div className="p-5  d-flex align-items-center justify-content-center">
        <input
          hidden
          type="file"
          id="p"
          accept="image/*"
          multiple
          style={{ width: "100%", backgroundColor: "#DFDFDF" }}
          className="form-control"
          onChange={(e)=>setimagePattern(e.target.files?.[0])}
        />
      <div className="row">
        <div className="col-lg-8">
          <label
            className="px-5 py-3 my-2 w-100 text-center"
            htmlFor="p"
            style={{
              backgroundColor: "rgb(245,245,245)",
              borderRadius: "9px",
              border: "2px dashed rgb(176,175,173)",
            }}
          >
            Upload Pattern image
          </label>
        </div>
      </div>
      </div> */}
                      </div>
                      {/* {dynamicImageURL && <div style={{width:"200px"}}><img src={dynamicImageURL} alt="" /></div>} */}
                      <div ref={divRef} id="img-download"></div>
                    </LoadingOverlay>
                  </>
                )}
              </div>

              <Stage />
            </div>
          </div>

          {/* </div> */}
        </div>
      </div>

      {/* <button className='d-flex justify-content-start' style={{backgroundColor:"blue",padding:"10px",color:"white",borderRadius:"10px"}} onClick={handleSelect}>Upload</button> */}
    </div>
  );
};

export default App;
